import { toast } from 'react-toastify';
import { Button } from '~/components/ui/Button';
import { pricingStore } from '~/lib/stores/pricing/pricing';
import { PricingPageOpenedTrigger } from '~/types/analytics';

export function FileSizeToast({ limit, isPaidUser }: { limit: number; isPaidUser?: boolean }) {
  return isPaidUser ? (
    <>The file size exceeds the maximum limit of {limit} MB. </>
  ) : (
    <>
      The file size exceeds the maximum limit of {limit} MB for free accounts.{' '}
      <Button
        className="inline"
        variant="link-color"
        onClick={() => {
          pricingStore.openPricingOverlay(PricingPageOpenedTrigger.SettingsTokenTab);
          toast.dismiss();
        }}
      >
        Increase limit
      </Button>
    </>
  );
}
